function ModalOverlay({ children }: { children: React.ReactNode }) {
  return (
    <div className="fixed inset-0 z-50 flex h-screen w-full items-end justify-center bg-black/60 backdrop-blur-sm">
      {children}
    </div>
  );
}

export default ModalOverlay;
